import { createEntityAdapter, Dictionary, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeature, createReducer, createSelector, on } from '@ngrx/store';

import { accountModuleActions } from './account-module.actions';
import { AccountModuleKey, AccountModuleToggle, accountModuleValueMap } from './account-module.model';

export interface AccountModuleState extends EntityState<AccountModuleToggle> {}

const adapter: EntityAdapter<AccountModuleToggle> = createEntityAdapter<AccountModuleToggle>({
  selectId: (e) => e.id,
});

export const accountModuleInitialState: AccountModuleState = adapter.getInitialState({});

export const accountModuleStore = createFeature({
  name: 'accountModules',
  reducer: createReducer(
    accountModuleInitialState,
    on(accountModuleActions.loaded, (state, { modules }) => adapter.setAll(modules, state)),
    on(accountModuleActions.updated, (state, { modules }) => adapter.upsertMany(modules, state)),
  ),
  extraSelectors: ({ selectEntities }) => ({
    selectModuleEnabled: (key: AccountModuleKey) =>
      createSelector(selectEntities, (modules) => isModuleEnabled(modules, key)),
    selectMinijobEnabled: createSelector(selectEntities, (modules) => isModuleEnabled(modules, 'minijob')),
    selectChatOptInEnabled: createSelector(selectEntities, (modules) => isModuleEnabled(modules, 'chatOptIn')),
  }),
});

const isModuleEnabled = (modules: Dictionary<AccountModuleToggle>, key: AccountModuleKey): boolean => {
  const id = accountModuleValueMap[key];
  return modules?.[id]?.enabled ?? false;
};
